import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PRICER_RISK_VIEWS, resolvePricerRiskView } from "../resolvePricerView";
import CreateHealth from "./Health";
import CreateRateLookup from "./RateLookup";
import CreateService from "./Service";
import CreateTerminal from "./Terminal";

const VIEW_BY_KEY = {
  [PRICER_RISK_VIEWS.health]: CreateHealth,
  [PRICER_RISK_VIEWS.terminal]: CreateTerminal,
  [PRICER_RISK_VIEWS.service]: CreateService,
  [PRICER_RISK_VIEWS.rateLookup]: CreateRateLookup,
};

const Create = (props) => {
  const { state } = useLocation();
  const risk = state && state.risk;
  const View = useMemo(() => VIEW_BY_KEY[resolvePricerRiskView(risk)], [risk]);

  return <View {...props} />;
};

export default Create;
